import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  loading: false,
  error: null,
  data: [],
  oneData: null,
};

export const bookingSlice = createSlice({
  name: 'booking',
  initialState,
  reducers: {
    getBookings: (state) => {
      state.loading = true;
    },
    updateBooking: (state) => {
      state.loading = true;
    },
    removeBooking: (state) => {
      state.loading = true;
    },
    getOneBooking: (state) => {
      state.loading = true;
    },
    successBooking: (state, action) => {
      state.loading = false;
      state.data = action.payload;
    },
    successOneBooking: (state, action) => {
      state.loading = false;
      state.oneData = action.payload;
    },
    failedBooking: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  getBookings,
  updateBooking,
  removeBooking,
  getOneBooking,
  successBooking,
  successOneBooking,
  failedBooking,
} = bookingSlice.actions;

export default bookingSlice.reducer;
